import { Component, OnInit, OnDestroy, AfterViewInit} from '@angular/core';
import { Router } from '@angular/router';
import { ResultAlert } from 'app/Shared/models';
import { Store } from '@ngrx/store';
import { AppState } from 'app/store/model';
import { UserActions } from 'app/Users/Services/actions';
import { Subscription } from 'rxjs';
import { ValidationResponseHandlerModule } from 'app/Shared/ValidationResponse/validation-response-handler';
import { SharedService } from 'app/Shared/Services/shared.service';
import { CameraActions } from 'app/cameras/Services/actions';
@Component({
    selector: 'app-user-partner-view',
    templateUrl: './user-partner-view.component.html',
    styleUrls: ['./user-partner-view.component.scss'],
    standalone: false
})
export class UserPartnerViewComponent implements OnInit, OnDestroy, AfterViewInit{
    readonly deletePartner$ = this.store.select((state: AppState) => state.Users.deletePartner);
    readonly userData$ = this.store.select((state: AppState) => state.Users.userData);

    loadingStock: boolean;


    delete_partner_sub: Subscription;
    swalDecisionSub: Subscription;
    activeTab: string;
    client_name: string;
    client_sub: string;
    user_sub: string;

    isMaster = localStorage.getItem('profile_name') === '7d4e9f24-17e8-11ec-9621-0242ac130002';
    isMasterAssociate = localStorage.getItem('profile_name') === '7415bb4a-c1e9-401d-870a-7af65a8e3acd';

    constructor(private router: Router, private readonly store: Store<AppState>, private validationResponse: ValidationResponseHandlerModule,
        private service: SharedService) { }

    ngOnInit(): void {
        this.client_name = localStorage.getItem('clientName');
        this.user_sub = localStorage.getItem('sub');
        this.client_sub = localStorage.getItem('clientView');
        this.subscribeStores();

        this.swalDecisionSub = this.service.swalDecision.subscribe(returnSwallObject => {
            if (returnSwallObject) {
                this.validateReturnMethodCalled(returnSwallObject as ResultAlert);
            }
        });

        this.delete_partner_sub = this.deletePartner$.subscribe(delete_partner => {
            if (delete_partner) {
                if (delete_partner.status === 2) {
                    this.validationResponse.validationResponseHandler(200, 'user', 'delete-partner-result', delete_partner.message);
                    this.goToList();
                } else {
                    this.validationResponse.validationResponseHandler(400, 'user', 'delete-partner-result-fail', delete_partner.message);
                    this.store.dispatch(UserActions.cleanup());
                    this.store.dispatch(UserActions.delete_partner_clear());
                }
            }
        });
    }

    ngOnDestroy() {
        if (this.delete_partner_sub) {
            this.delete_partner_sub.unsubscribe();
        }
        if (this.swalDecisionSub) {
            this.swalDecisionSub.unsubscribe();
        }

        this.store.dispatch(CameraActions.cleanup());
        this.store.dispatch(UserActions.cleanup());
        this.store.dispatch(UserActions.delete_partner_clear());
        this.service.cleanSwal();
    }

    ngAfterViewInit(): void {
        const savedTab = localStorage.getItem('activeTab');
        if (savedTab) {
            this.activeTab = savedTab;
        }
        else {
            this.activeTab = 'info';
        }
    }

    goToList() {
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate(['/users/partners']);
    }

    changeTab(event) {
        const tabs = document.querySelectorAll('.btn-tab');
        tabs.forEach(element => {
            element.classList.remove('active');
        });
        event.currentTarget.classList.add('active');
        this.activeTab = event.currentTarget.id;
    }

    viewPartnerList() {
        this.router.navigateByUrl('users/partners');
    }

    validateReturnMethodCalled(returnResultSwal: ResultAlert) {
        if (returnResultSwal.methodCalled === 'deletePartner') {
            if (returnResultSwal.isConfirmed) {
                this.store.dispatch(UserActions.delete_partner({
                    sub: this.user_sub,
                    child_sub: this.client_sub
                }));
            }
        }
    }

    subscribeStores() {
        this.userData$.subscribe((client_data) => {
            if (client_data) {
                if (client_data.model === 'feedback') {
                    this.validationResponse.validationResponseHandler(400, 'user-summary', 'return-data-error', 'user.client_cognito_error', client_data.data);
                }
                else {
                    if (client_data.sub != this.user_sub) {
                        this.client_name = client_data.name;
                    }
                }
            }
        });
    }

}
